module.exports = __webpack_public_path__ + "static/media/banner-novo2-2024.2013876e.jpg";